<script>
import ClientesService from '@/services/clientes.service';
import Utils from '@/functions/utils';
import { RegistroEstadoContador } from '@/constants/global';
import spinnerService from '@/services/spinner.service';

export default {

  data() {
    return {
      loading: false,
      errores: {},
      recomendado: {},
      contadordb: null
    }
  },
  methods: {
    btnCancelar_click() {
      this.$router.push({
        path: `/`
      });
    },
    async btnBuscar_click() {
      if (this.loading) return;
      this.errores.documento = this.recomendado.documento == null || this.recomendado.documento.trim() == '';
      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) {
        Utils.mostrarMensajeError('Por favor, ingrese el número de DNI')
        return;
      }
      this.loading = true;
      spinnerService.show();
      try {
        let res = await ClientesService.getContadorPorDocumento(this.recomendado.documento);
        this.loading = false;
        if (res == null) {
          Utils.mostrarMensajeError('El DNI ingresado no está registrado')
          return;
        }
        if (res.confirmacion != RegistroEstadoContador.CONFIRMADO) {
          Utils.mostrarMensajeErrorConTitulo('No Autorizado','Comuniquese con nosotros para más información')
          return;
        }
        this.contadordb = res;
        this.recomendado.nombre = res.razonSocial;
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeError(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }

    },
    async btnGuardar_click() {
      if (this.loading) return;
      //VALIDACIONES
      this.errores.contador = this.contadordb == null;
      this.errores.documento = this.recomendado.documento == null || this.recomendado.documento.trim() == '';
      this.errores.nombre = this.recomendado.nombre == null || this.recomendado.nombre.trim() == '';
      this.errores.nombreCompleto = this.recomendado.nombreCompleto == null || this.recomendado.nombreCompleto.trim() == '';
      this.errores.telefono = this.recomendado.telefono == null || this.recomendado.telefono.trim() == '';
      this.errores.ciudad = this.recomendado.ciudad == null || this.recomendado.ciudad.trim() == '';
      this.errores.rubro = this.recomendado.rubro == null || this.recomendado.rubro.trim() == '';
      if (this.errores.contador) {
        Utils.mostrarMensajeAdvertencia('Ingrese datos de contador')
        return;
      }
      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) return;

      this.loading = true;
      spinnerService.show();
      try {
        let obj = {
          Nombre: this.recomendado.nombreCompleto,
          Telefono: this.recomendado.telefono,
          Ciudad: this.recomendado.ciudad,
          Rubro: this.recomendado.rubro,
          Comentario: this.recomendado.comentarios,
          FechaRegistro: new Date(),
          
          IdAsesor: (this.contadordb && this.contadordb.idAsesor) || 0,
          IdContador: (this.contadordb && this.contadordb.id) || 0,
        };

        await ClientesService.createRecomendado(obj);
        Utils.mostrarMensajeExito('Se ha guardado exitosamente');
        this.loading = false;
        this.$router.push({
          path: `/felicidades-recomendado`
        });
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeAdvertencia(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }

    }
  }
};

</script>
<template>
  <div class="space"></div>
  <div class="container conts">
    <div class="row">
      <div class="col"></div>
      <div class="col-sm-9">
        <div class="recuadro bg-white mt-5 mb-5">
          <div class="text-center head bg-primary bg-gradient text-white p-4">
            <h1>REGISTRA A TU RECOMENDADO</h1>
            <p>POR FAVOR COMPLETA TUS DATOS COMO RECOMENDADOR</p>
          </div>
          <div class="card-body p-5">
            <form>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Por favor ingresa tus datos como recomendador</h2>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-4">
                  <label for="dni" class="form-label form-control-lg">Número de DNI</label>
                </div>
                <div class="col-sm-8">
                  <div class="input-group">
                    <input type="text" class="req form-control form-control-lg" name="b_dni" id="b_dni" @keyup.enter="btnBuscar_click"
                      v-model="recomendado.documento" v-bind:class="{ 'invalid': errores.documento }">
                    <button class="btn btn-primary btn-lg" type="button" @click="btnBuscar_click" id="button-addon2"><i
                        class="fas fa-search"></i>
                      Buscar</button>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-4">
                  <label for="nombre" class="form-label form-control-lg">Nombre</label>
                </div>
                <div class="col-sm-8">
                  <div class="input-group">
                    <input type="text" class="req form-control form-control-lg" v-model="recomendado.nombre"
                      v-bind:class="{ 'invalid': errores.nombre }" disabled>
                  </div>
                </div>
              </div>
            </form>
            <form id="regis" action="/recomendado" method="POST">

              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Por favor completa los datos de tu recomendado</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="nombre" class="form-control-lg">Nombre Completo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_nombre" id="recom_nombre"
                      maxlength="255" v-model="recomendado.nombreCompleto"
                      v-bind:class="{ 'invalid': errores.nombreCompleto }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="nombre" class="form-control-lg">Teléfono</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_telefono" id="recom_telefono"
                      maxlength="20" v-model="recomendado.telefono" v-bind:class="{ 'invalid': errores.telefono }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="ciudad" class="form-control-lg">Ciudad</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_ciudad" id="recom_ciudad"
                      maxlength="255" v-model="recomendado.ciudad" v-bind:class="{ 'invalid': errores.ciudad }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="rubro" class="form-control-lg">Rubro del negocio</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_rubro" id="recom_rubro"
                      maxlength="255" v-model="recomendado.rubro" v-bind:class="{ 'invalid': errores.rubro }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="rubro" class="form-control-lg">Comentarios adicionales</label>
                  </div>
                  <div class="col-sm-7">
                    <textarea class="form-control form-control-lg" name="recom_comentario" id="recom_comentario" rows="3"
                      maxlength="255" placeholder="OPCIONAL" v-model="recomendado.comentarios"></textarea>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <input type="hidden" name="recom_fec_registro" id="recom_fec_registro">
                  <div class="col"><a @click="btnCancelar_click" class="btn btn-danger form-control btn-lg">Cancelar</a>
                  </div>
                  <div class="col"></div>
                  <div class="col"><button type="button" id="guardar" class="btn btn-primary form-control btn-lg"
                      @click="btnGuardar_click">Guardar</button></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>